/*
 * Authors: mariushirjanu
 * Created: 01/12/2023
 */
import * as _ from 'underscore';
import { Directive, ElementRef, EventEmitter, Inject, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { cssUtil } from '../util';

export interface ITrackVisibilityOptions {
  topMarginExclude?:string;
  threshold?:number;
}

@Directive({
  selector: '[trackVisibility]'
})
export class TrackVisibilityDirective implements OnInit, OnDestroy {
  @Input('trackVisibility') public trackVisibilityOptions:ITrackVisibilityOptions;
  @Output() public isVisible:EventEmitter<boolean> = new EventEmitter<boolean>();
  private observer!:IntersectionObserver;

  constructor(
    private el:ElementRef<HTMLElement>,
    private ngZone:NgZone,
    @Inject(DOCUMENT) private document:Document
  ) {
    /**/
  }

  public ngOnInit():void {
    this.listen();
  }

  private listen():void {
    this.ngZone.runOutsideAngular(() => {
      const observerOptions = {
        threshold: this.trackVisibilityOptions?.threshold || 0.5,
        rootMargin: this.rootMargin
      };

      const observerCallback:IntersectionObserverCallback = (entries:IntersectionObserverEntry[]) => {
        _.each(entries, (e:IntersectionObserverEntry) => {
          this.isVisible.emit(e.isIntersecting);
        });
      };

      this.observer = new IntersectionObserver(observerCallback, observerOptions);
      this.observer.observe(this.el.nativeElement);
    });
  }

  private get rootMargin():string {
    const topMargin:number = cssUtil.sumHeights(this.trackVisibilityOptions.topMarginExclude);
    return `-${topMargin}px 0px 0px 0px`;
  }

  public ngOnDestroy():void {
    this.observer.disconnect();
  }
}